const messages = {
  addCoupon: 'Agregar cupón',
  inputCoupon: 'Ingresa cupón de descuento',
  errorCoupon: 'Cupón invalido',
  close: 'X',
  coupon: 'Cupón',
}

export default messages
